<template>
  <div class="main">
    <a-row>
      <a-col :span="11">
        <div class="code-tag">
          <a-tag color="pink">
            旧
          </a-tag>
        </div>
        <div class="code-box">
          <div style="margin-top:10px">
            <h1 class="code-title">
              {{ history.title }}
            </h1>
            <h2 class="code-subtitle" v-if="history.subtitle != ''">
              ——{{ history.subtitle }}
            </h2>
            <div class="code-content" v-html="key.value1"></div>
          </div>
        </div>
      </a-col>
      <a-col :span="11" offset="1">
        <div class="code-tag">
          <a-tag color="green">
            新
          </a-tag>
        </div>
        <div class="code-box">
          <div style="margin-top:10px">
            <h1 class="code-title">
              {{ article.title }}
            </h1>
            <h2 class="code-subtitle" v-if="article.subtitle != ''">
              ——{{ article.subtitle }}
            </h2>
            <div v-html="key.value2"></div>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-modal v-model="visible" title="确定回滚至该版本么？" @ok="handleOk">
      <p>
        版本回退只会恢复文章的标题、副标题、来源、内容、摘要、标题图、外链、关键词,且文章状态会退为草稿，已审核的文章无法回滚
      </p>
    </a-modal>
    <footer-tool-bar>
      <a-button type="primary" @click="rollback">回滚</a-button>
      <a-button
        @click="
          () => {
            this.$router.go(-1);
          }
        "
        >返回</a-button
      >
    </footer-tool-bar>
  </div>
</template>

<script>
import FooterToolBar from '../../components/FooterToolBar';
export default {
  components: { FooterToolBar },
  data() {
    return {
      history_id: 0,
      article_id: 0,
      article: {},
      history: {},
      visible: false,
      key: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getHistoryDetail(id) {
      await this.$http.post('api/content/historyDetail', { id }).then(res => {
        if (res.data.state === 200) {
          this.history = res.data.data;
          this.history.content = this.htmlRestore(this.history.content);
        }
      });
    },
    async getArticle(id) {
      await this.$http.post('api/content/clouddetail', { id }).then(res => {
        if (res.data.state === 200) {
          this.article = res.data.data;
          this.article.content = this.htmlRestore(this.article.content);
        }
      });
    },
    rollback() {
      this.visible = true;
    },
    handleOk() {
      if (this.article.status === '100') {
        this.$message.error('已审核的文章无法回滚');
        return false;
      } else {
        this.$http
          .post('api/content/historyRecover', { id: this.history_id })
          .then(res => {
            if (res.data.state === 200) {
              this.$message.success('回滚成功，请重新打开文章');
              this.$router.go(-1);
            } else {
              this.$message.error('回滚失败');
            }
          });
      }
    },

    htmlRestore(str) {
      let s = '';
      if (str.length === 0) {
        return '';
      }
      s = str.replace(/<[^>]+>/g, '');
      s = s.replace(/&nbsp;/g, '');
      s = s.replace(/&amp;/g, '&');
      s = s.replace(/&lt;/g, '<');
      s = s.replace(/&gt;/g, '>');
      s = s.replace(/&nbsp;/g, ' ');
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      s = s.replace(/4&times;/g, '×');
      return s;
    },
    _eq(op) {
      if (!op) {
        return op;
      }
      if (!op.value1_style) {
        op.value1_style = 'background-color:#FEC8C8;';
      }
      if (!op.value2_style) {
        op.value2_style = 'background-color:#FEC8C8;';
      }
      if (!op.eq_min) {
        op.eq_min = 3;
      }
      if (!op.eq_index) {
        op.eq_index = 5;
      }
      if (!op.value1 || !op.value2) {
        return op;
      }
      var ps = {
        v1_i: 0,
        v1_new_value: '',
        v2_i: 0,
        v2_new_value: ''
      };
      while (ps.v1_i < op.value1.length && ps.v2_i < op.value2.length) {
        if (op.value1[ps.v1_i] == op.value2[ps.v2_i]) {
          ps.v1_new_value += op.value1[ps.v1_i]
            .replace(/</g, '<')
            .replace('>', '>');
          ps.v2_new_value += op.value2[ps.v2_i]
            .replace(/</g, '<')
            .replace('>', '>');
          ps.v1_i += 1;
          ps.v2_i += 1;
          if (ps.v1_i >= op.value1.length) {
            ps.v2_new_value +=
              "<span style='" +
              op.value2_style +
              "'>" +
              op.value2
                .substr(ps.v2_i)
                .replace(/</g, '<')
                .replace('>', '>') +
              '</span>';
            break;
          }
          if (ps.v2_i >= op.value2.length) {
            ps.v1_new_value +=
              "<span style='" +
              op.value1_style +
              "'>" +
              op.value1
                .substr(ps.v1_i)
                .replace(/</g, '<')
                .replace('>', '>') +
              '</span>';
            break;
          }
        } else {
          ps.v1_index = ps.v1_i + 1;
          ps.v1_eq_length = 0;
          ps.v1_eq_max = 0;
          ps.v1_start = ps.v1_i + 1;
          while (ps.v1_index < op.value1.length) {
            if (
              op.value1[ps.v1_index] == op.value2[ps.v2_i + ps.v1_eq_length]
            ) {
              ps.v1_eq_length += 1;
            } else if (ps.v1_eq_length > 0) {
              if (ps.v1_eq_max < ps.v1_eq_length) {
                ps.v1_eq_max = ps.v1_eq_length;
                ps.v1_start = ps.v1_index - ps.v1_eq_length;
              }
              ps.v1_eq_length = 0;
              break; //ֻѰ�������
            }
            ps.v1_index += 1;
          }
          if (ps.v1_eq_max < ps.v1_eq_length) {
            ps.v1_eq_max = ps.v1_eq_length;
            ps.v1_start = ps.v1_index - ps.v1_eq_length;
          }

          ps.v2_index = ps.v2_i + 1;
          ps.v2_eq_length = 0;
          ps.v2_eq_max = 0;
          ps.v2_start = ps.v2_i + 1;
          while (ps.v2_index < op.value2.length) {
            if (
              op.value2[ps.v2_index] == op.value1[ps.v1_i + ps.v2_eq_length]
            ) {
              ps.v2_eq_length += 1;
            } else if (ps.v2_eq_length > 0) {
              if (ps.v2_eq_max < ps.v2_eq_length) {
                ps.v2_eq_max = ps.v2_eq_length;
                ps.v2_start = ps.v2_index - ps.v2_eq_length;
              }
              ps.v1_eq_length = 0;
              break; //ֻѰ�������
            }
            ps.v2_index += 1;
          }
          if (ps.v2_eq_max < ps.v2_eq_length) {
            ps.v2_eq_max = ps.v2_eq_length;
            ps.v2_start = ps.v2_index - ps.v2_eq_length;
          }
          if (ps.v1_eq_max < op.eq_min && ps.v1_start - ps.v1_i > op.eq_index) {
            ps.v1_eq_max = 0;
          }
          if (ps.v2_eq_max < op.eq_min && ps.v2_start - ps.v2_i > op.eq_index) {
            ps.v2_eq_max = 0;
          }
          if (ps.v1_eq_max == 0 && ps.v2_eq_max == 0) {
            ps.v1_new_value +=
              "<span style='" +
              op.value1_style +
              "'>" +
              op.value1[ps.v1_i].replace(/</g, '<').replace('>', '>') +
              '</span>';
            ps.v2_new_value +=
              "<span style='" +
              op.value2_style +
              "'>" +
              op.value2[ps.v2_i].replace(/</g, '<').replace('>', '>') +
              '</span>';
            ps.v1_i += 1;
            ps.v2_i += 1;

            if (ps.v1_i >= op.value1.length) {
              ps.v2_new_value +=
                "<span style='" +
                op.value2_style +
                "'>" +
                op.value2
                  .substr(ps.v2_i)
                  .replace(/</g, '<')
                  .replace('>', '>') +
                '</span>';
              break;
            }
            if (ps.v2_i >= op.value2.length) {
              ps.v1_new_value +=
                "<span style='" +
                op.value1_style +
                "'>" +
                op.value1
                  .substr(ps.v1_i)
                  .replace(/</g, '<')
                  .replace('>', '>') +
                '</span>';
              break;
            }
          } else if (ps.v1_eq_max > ps.v2_eq_max) {
            ps.v1_new_value +=
              "<span style='" +
              op.value1_style +
              "'>" +
              op.value1
                .substr(ps.v1_i, ps.v1_start - ps.v1_i)
                .replace(/</g, '<')
                .replace('>', '>') +
              '</span>';
            ps.v1_i = ps.v1_start;
          } else {
            ps.v2_new_value +=
              "<span style='" +
              op.value2_style +
              "'>" +
              op.value2
                .substr(ps.v2_i, ps.v2_start - ps.v2_i)
                .replace(/</g, '<')
                .replace('>', '>') +
              '</span>';
            ps.v2_i = ps.v2_start;
          }
        }
      }
      op.value1 = ps.v1_new_value;
      op.value2 = ps.v2_new_value;
      return op;
    }
  },
  async created() {
    if (this.$route.query.id) {
      this.history_id = this.$route.query.id;
      await this.getHistoryDetail(this.history_id);
    }
    if (this.$route.query.article_id) {
      this.article_id = this.$route.query.article_id;
      await this.getArticle(this.article_id);
    }
    this.key = this._eq({
      value1: this.history.content,
      value2: this.article.content
    });

    console.log(key);
  },
  mounted() {}
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.code-box {
  border: 1px solid #ebedf0;
  border-radius: 2px;
  position: relative;
  transition: all 0.2s;
  min-height: 600px;
  padding: 5px 15px;
}
.code-tag {
  position: absolute;
  top: 0px;
  left: 0px;
}
.code-title {
  text-align: center;
}
.code-information {
  text-align: right;
  color: #888;
}
.code-subtitle {
  text-align: center;
  text-indent: 3em;
}
.code-content >>> image,
.code-content >>> video,
.code-content >>> img {
  max-width: 500px;
  display: block;
  margin: 0 auto;
}
</style>
